import { useAuthStore } from '../../store/auth.store';
import { AdminSettingsModal } from './AdminSettingsModal';
import { DeveloperSettingsModal } from './DeveloperSettingsModal';

interface ProfileSettingsModalProps {
  opened: boolean;
  onClose: () => void;
  initialTab?: string;
}

export function ProfileSettingsModal({ opened, onClose, initialTab }: ProfileSettingsModalProps) {
  const { user } = useAuthStore();
  const isAdmin = user?.role === 'platform_admin' || user?.role === 'admin';

  if (!opened) return null;

  if (isAdmin) {
    return <AdminSettingsModal opened={opened} onClose={onClose} />;
  }

  return <DeveloperSettingsModal opened={opened} onClose={onClose} initialTab={initialTab} />;
}
